import { useState } from "react";
import {
  BLOCKED,
  BROWSER_ALERTS_HEADING,
  ENABLE,
  ON,
  UNSUPPORTED,
} from "../lib/adminAlerts";

type Permission = NotificationPermission | "unsupported";

function currentPermission(): Permission {
  return typeof Notification === "undefined" ? "unsupported" : Notification.permission;
}

// BrowserAlertsSetting (0064): this browser's permission for the admin's
// alert notifications (AdminAlertNotifier). A browser grants it only from a
// click, once per browser, so the row is one state or one act.
export function BrowserAlertsSetting() {
  const [permission, setPermission] = useState<Permission>(currentPermission);
  const [asking, setAsking] = useState(false);

  const enable = async () => {
    if (typeof Notification === "undefined") {
      setPermission("unsupported");
      return;
    }
    setAsking(true);
    try {
      setPermission(await Notification.requestPermission());
    } finally {
      setAsking(false);
    }
  };

  return (
    <section className="rounded-md border border-ink-800 bg-ink-900/40 p-6 mt-6">
      <div className="flex items-baseline justify-between gap-4">
        <h2 className="text-base font-medium text-ink-50">{BROWSER_ALERTS_HEADING}</h2>
        {permission === "default" && (
          <button
            type="button"
            onClick={enable}
            disabled={asking}
            className="rounded-md border border-ink-700 bg-ink-900/30 px-3 py-1.5 text-xs text-ink-100 hover:border-ink-600 transition-colors disabled:cursor-not-allowed disabled:text-ink-500"
          >
            {ENABLE}
          </button>
        )}
        {permission === "granted" && <span className="text-sm text-emerald-300">{ON}</span>}
        {permission === "denied" && <span className="text-sm text-amber-300">{BLOCKED}</span>}
        {permission === "unsupported" && (
          <span className="text-sm text-ink-400">{UNSUPPORTED}</span>
        )}
      </div>
    </section>
  );
}
